// Smart category shortcuts — common questions per area
export const CATEGORIES = [
  {
    key: "civil",
    title: "Direito Civil",
    subtitle: "Contratos, família, sucessões, danos",
    icon: "BookOpen",
    chips: [
      "Como funciona o inventário e partilha de bens?",
      "Posso anular um contrato assinado sob pressão?",
      "Quais os direitos em caso de divórcio com filhos menores?",
      "Como cobrar uma dívida pelo Código Civil?",
      "Quando cabe indenização por danos morais?",
    ],
  },
  {
    key: "trabalhista",
    title: "Direito Trabalhista",
    subtitle: "CLT, rescisão, horas extras, FGTS",
    icon: "Briefcase",
    chips: [
      "Quais verbas tenho direito ao ser demitido sem justa causa?",
      "Como calcular horas extras e adicional noturno?",
      "Posso pedir rescisão indireta? Em quais casos?",
      "Tenho direito a equiparação salarial?",
      "Qual o prazo para entrar com ação trabalhista?",
    ],
  },
  {
    key: "previdenciario",
    title: "Direito Previdenciário",
    subtitle: "INSS, aposentadoria, BPC, auxílios",
    icon: "ShieldCheck",
    chips: [
      "Quais as regras atuais de aposentadoria por tempo de contribuição?",
      "Como funciona a aposentadoria por idade após a Reforma?",
      "Tenho direito ao BPC/LOAS? Quem pode receber?",
      "Como pedir o auxílio-doença pelo INSS?",
      "Posso revisar minha aposentadoria? Qual o prazo?",
    ],
  },
  {
    key: "consumidor",
    title: "Direito do Consumidor",
    subtitle: "CDC, compras, cobrança indevida, vícios",
    icon: "ShoppingBag",
    chips: [
      "Comprei um produto com defeito, quais meus direitos?",
      "Fui cobrado indevidamente, posso receber em dobro?",
      "Como cancelar uma compra feita pela internet?",
      "Banco fez débito não autorizado — o que fazer?",
      "Nome inscrito indevidamente no SPC/Serasa, o que fazer?",
    ],
  },
];
